<div class="close" [ngClass]="alignment">
  <button mat-icon-button type="button">
    <fa-icon icon="times" xIconSize="small"></fa-icon>
  </button>
</div>
